import PaymentMethods from "@/models/loyaltyPanel/subscriptions/PaymentMethods";
import router from '@/routes'
import BillingDashboard from "@/models/general/settings/BillingDashboard";

export default {
    namespaced: true,

    state: () => ({
        companyPaymentMethods: [],
        systemPaymentMethods: [],
        paymentMethod: new PaymentMethods(),
        paymentMethodAdditionalInfo: {},
        lang: '',
        paymentMethods: null,
        selectedMethod: null,
    }),

    mutations: {
        
        setPaymentMethods(state, payload) {
            state.paymentMethods = payload;
        },
        setSelectedMethod(state, payload) {
            state.selectedMethod = payload;
        },


        setCompanyPaymentMethods(state, payload) {
            state.companyPaymentMethods = payload;
        },
        setSystemPaymentMethods(state, payload) {
            state.systemPaymentMethods = payload;
        },
        setPaymentMethod(state, payload) {
            state.paymentMethod = new PaymentMethods(payload);
        },
        setPaymentMethodAdditionalInfo(state, payload) {
            state.paymentMethodAdditionalInfo = payload;
        },
        setLanguage(state, payload){
            state.lang = payload;
        }
    },

    actions: {
        
        
        async getPaymentMethods({ commit, state }) {
            try {

                const { data } = await BillingDashboard.getPaymentMethods();

                commit("setPaymentMethods", data.data.payment_methods);
                commit("setSelectedMethod", data.data.payment_methods.find(x => x.selecteds) || data.data.payment_methods?.[2]);
                commit("setLoading", false, { root: true });
                
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async getCompanyPaymentMethods({ commit,state }){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await PaymentMethods.getCompanyPaymentMethods();
    
                const paymentMethods = data.data
                commit("setCompanyPaymentMethods", paymentMethods);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },
        
        async getSystemPaymentMethods({ commit }){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await PaymentMethods.getSystemPaymentMethods();
                const paymentMethods = data.data
                paymentMethods.map(item => {
                    item.title = item.name[router.currentRoute.params.lang] + " (" + item.system_payment_method_category.name[router.currentRoute.params.lang] + ")"
                })
                commit("setSystemPaymentMethods", paymentMethods);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getPaymentMethodProfile({ commit } , id){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await PaymentMethods.getPaymentMethodProfile(id);
                
                const paymentMethod = data.data
                commit("setPaymentMethod", paymentMethod);
                commit("setDialog", true, { root: true });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async createPaymentMethod({ commit, dispatch, state }) {
            try {
                commit("setLoading", true, { root: true });

                let paymentMethod = { ...state.paymentMethod };
                delete paymentMethod.store_payment_method_id;

                await PaymentMethods.create(paymentMethod);
                
                dispatch("getCompanyPaymentMethods")
                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully created payment method!"
                    },
                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async updatePaymentMethod({ commit, dispatch, state }) {
            try {
                commit("setLoading", true, { root: true });

                let paymentMethod = { ...state.paymentMethod };
                let id = paymentMethod.store_payment_method_id
                delete paymentMethod.store_payment_method_id;

                await PaymentMethods.update(paymentMethod,id);
                
                dispatch("getCompanyPaymentMethods")
                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully updated payment method!"
                    },
                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async removePaymentMethod({ commit, dispatch }, id) {
            try {
                commit("setLoading", true, { root: true });
                
                await PaymentMethods.delete(id);

                dispatch("getCompanyPaymentMethods")
                commit("setLoading", false, { root: true });
                commit("setDeleteDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully deleted payment method!"
                    },

                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        }

    }
        
};
